export default function HowItWorksSection() {
  const steps = [
    {
      num: '01',
      icon: 'ri-search-eye-line',
      title: 'Find Your Spreadsheet',
      desc: 'Browse our organized Vigorbuy Spreadsheet categories to locate the product type you are interested in. Each category contains curated product listings ready for your review.',
    },
    {
      num: '02',
      icon: 'ri-scales-3-line',
      title: 'Compare Products',
      desc: 'Use the Vigorbuy Spreadsheet format to compare multiple products side by side. View key details, pricing, and features all in one organized view without switching tabs.',
    },
    {
      num: '03',
      icon: 'ri-information-line',
      title: 'Check Information',
      desc: 'Review detailed product information compiled in the Vigorbuy Spreadsheet. Verify specifications, availability, and other important details before making your decision.',
    },
    {
      num: '04',
      icon: 'ri-external-link-line',
      title: 'Visit Main Website',
      desc: 'Once you have identified the products you want, follow the direct links to the main website to complete your purchase with confidence.',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            How <span className="text-accent-600">Vigorbuy Spreadsheet</span> Works
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Getting started with Vigorbuy Spreadsheet is simple. Follow these four easy steps to transform your shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {steps.map((step, idx) => (
            <div
              key={step.num}
              className="relative bg-background-50 rounded-xl p-5 md:p-6 border border-background-200 hover:border-accent-200 transition-all duration-300 group"
            >
              <span className="text-4xl md:text-5xl font-heading font-extrabold text-accent-100 group-hover:text-accent-200 transition-colors">
                {step.num}
              </span>
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 my-3">
                <i className={`${step.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}